// Compact wordmark — "Cholos vs Emos" with the three-script signature
// preserved at small sizes. Used in the Menu header and any sub-route nav bar.

interface WordMarkProps {
  size?: 'sm' | 'md' | 'lg';
}

export function WordMark({ size = 'sm' }: WordMarkProps) {
  const cls =
    size === 'lg'
      ? 'text-[32px] md:text-[44px] lg:text-[56px]'
      : size === 'md'
        ? 'text-[28px] md:text-[36px] lg:text-[44px]'
        : 'text-[20px] md:text-[26px] lg:text-[32px]';

  return (
    <span
      className={`inline-flex items-baseline gap-[0.4em] leading-none ${cls}`}
    >
      <span className="font-cholo text-cholo">Cholos</span>
      <span className="font-data text-[0.55em] uppercase tracking-[0.2em] text-sodium">
        vs.
      </span>
      <span className="font-emo text-emo">Emos</span>
    </span>
  );
}
